import type { Layout } from "../../../types";
import margin from "./margin.module.scss";
import bigMargin from "./big-margin.module.scss";
import horizontal2 from "./horizontal-2.module.scss";
import vertical2 from "./vertical-2.module.scss";
import photos3 from "./photos-3.module.scss";
import photos3Vertical from "./photos-3-vertical.module.scss";
import photos4 from "./photos-4.module.scss";
import round from "./round.module.scss";

// Calendar pages have ~1.3 aspect ratio (landscape)
// Aspect ratios calculated for each photo slot

const layouts: Layout[] = [
  {
    value: "margin",
    label: "Avec marge",
    countPhotos: 1,
    countLabels: 0,
    style: margin,
    photoAspectRatios: [1.3],
  },
  {
    value: "big-margin",
    label: "Marge large",
    countPhotos: 1,
    countLabels: 0,
    style: bigMargin,
    photoAspectRatios: [1.3],
  },
  {
    value: "horizontal-2",
    label: "Séparateur horizontal",
    countPhotos: 2,
    countLabels: 0,
    style: horizontal2,
    photoAspectRatios: [2.7, 2.7],
  },
  {
    value: "vertical-2",
    label: "Séparateur vertical",
    countPhotos: 2,
    countLabels: 0,
    style: vertical2,
    photoAspectRatios: [0.63, 0.63],
  },
  {
    value: "photos-3",
    label: "Trois photos",
    countPhotos: 3,
    countLabels: 0,
    style: photos3,
    photoAspectRatios: [1.3, 1.3, 2.7],
  },
  {
    value: "photos-3-vertical",
    label: "Trois photos verticales",
    countPhotos: 3,
    countLabels: 0,
    style: photos3Vertical,
    photoAspectRatios: [0.42, 0.42, 0.42],
  },
  {
    value: "photos-4",
    label: "Quatre photos",
    countPhotos: 4,
    countLabels: 0,
    style: photos4,
    photoAspectRatios: [1.3, 1.3, 1.3, 1.3],
  },
  {
    value: "round",
    label: "Photo arrondie",
    countPhotos: 1,
    countLabels: 0,
    style: round,
    photoAspectRatios: [1],
    photoCropShapes: ["round"],
  },
];

export default layouts;
